import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { Tooltip } from '@domains/pdp-common';

import { InfoIcon } from '../assets/InfoIcon';
import { MoreButton } from '../components/MoreButton';
import { RecommendTooltip } from '../components/RecommendTooltip';
import { SimilarSize } from '../components/SimilarSize';
import { SimilarSizeOption } from '../components/SimilarSizeOption';
import { SimilarSizeOptionList } from '../components/SimilarSizeOptionList';
import { UserFigure } from '../components/UserFigure';
import { useLegacySimilarSizeService } from '../services/useLegacySimilarSizeService';

export const LegacySimilarSizeContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const {
    tooltipRef,
    handleInfoClick,
    isTooltipShown,
    title,
    isPurchaseType,
    recommendOption,
    language,
    userAccount,
    recommendOptionValueList,
    moreVisible,
    handleMoreClick,
    infoOpen,
    closeTooltip,
    isOptionType,
  } = useLegacySimilarSizeService();
  return (
    <Wrapper hasTooltip={isTooltipShown}>
      <SimilarSize ref={tooltipRef}>
        <SimilarSize.Header className={Typography.BODY_17_BOLD}>
          <SimilarSize.TooltipTrigger aria-label='사이즈 추천 안내 버튼' onClick={handleInfoClick}>
            <InfoIcon />
          </SimilarSize.TooltipTrigger>
          {isTooltipShown && (
            <Tooltip
              text='체형에 맞는 사이즈를 확인해 보세요'
              arrowPosition={{ direction: 'down', position: 'left' }}
              top='-40px'
              left='24px'
              zIndex={190}
            />
          )}
          <SimilarSize.Title>{title}</SimilarSize.Title>
          <SimilarSize.Subtitle>
            <SimilarSize.Pink>{recommendOption}</SimilarSize.Pink>{' '}
            <SimilarSize.Sticky lang={language}>
              {isPurchaseType ? '사이즈를 많이 구매했어요' : '사이즈를 추천해요'}
            </SimilarSize.Sticky>
          </SimilarSize.Subtitle>
        </SimilarSize.Header>
        <UserFigure userAccount={userAccount} />
        <SimilarSizeOptionList
          items={recommendOptionValueList}
          renderItem={(item) => {
            return (
              <SimilarSizeOption
                key={item.ranking + item.name}
                ranking={item.ranking}
                name={item.name}
                purchasePercent={item.purchasePercent}
                answer={item.answer}
              />
            );
          }}
        />
        <MoreButton visible={moreVisible} onClick={handleMoreClick}>
          더 보기
        </MoreButton>
        <RecommendTooltip open={infoOpen} onClose={closeTooltip} isOptionType={isOptionType} />
      </SimilarSize>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ hasTooltip: boolean }>`
  ${({ hasTooltip }) => hasTooltip && `padding-top: 16px;`};
`;
